// extracted by mini-css-extract-plugin
export default {"icon-button--custom-focus":"IconButton_icon-button--custom-focus__+QWTW"};